/** @jsxImportSource @emotion/react */
import { createStyles, Modal, Typography } from '@quickbit/qb-design-system';

interface Props {
  travelRuleData: Record<string, unknown> | null;
  onClose: () => void;
}

export const TravelRuleDetailsModal = ({ travelRuleData, onClose }: Props) => {
  const styles = useStyles();

  return (
    <Modal
      title="Travel Rule Details"
      secondaryButtonProps={{
        text: 'Close',
        onClick: onClose,
      }}
    >
      <div css={styles.container}>
        {travelRuleData ? (
          <pre css={styles.jsonContent}>
            {JSON.stringify(travelRuleData, null, 2)}
          </pre>
        ) : (
          <Typography variant="body">No travel rule data available</Typography>
        )}
      </div>
    </Modal>
  );
};

const useStyles = createStyles(({ spacing, palette }) => ({
  container: {
    maxHeight: '60vh',
    overflow: 'auto',
  },
  jsonContent: {
    backgroundColor: palette.grey.x200,
    padding: spacing.s,
    borderRadius: spacing.xxxs,
    fontSize: '12px',
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    margin: 0,
  },
}));
